import React from 'react'
import '../style/counter.scss'

export default props => (
  <div className="counter">{props.count}</div>
)


// WEBPACK FOOTER //
// ./src/components/Counter.js